export default "__VITE_ASSET__c9561897__"